import { Grid, FormControlLabel, Checkbox, Box, RadioGroup, Radio } from '@mui/material'

type TranslationFn = (key: string) => string

type OmittedFormData = {
  CheckUseScheduleTime: boolean
  RadioUseScheduleTime: string
  CheckTreatAsAnException: boolean
}

interface OmittedProps {
  t: TranslationFn
  loadingGettingRounding?: boolean
  formData: OmittedFormData
  updateFormData: <K extends keyof OmittedFormData>(field: K, value: OmittedFormData[K]) => void
}

const Omitted = ({
  t,
  loadingGettingRounding = false,
  formData,
  updateFormData
}: OmittedProps) => {
  return (
    <>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
          <FormControlLabel
            label={t('settings.rounding_rule.table.modals.add.tabs.omitted_punch.use_schedule_time')}
            control={
              <Checkbox
                checked={formData.CheckUseScheduleTime}
                onChange={(event) => updateFormData('CheckUseScheduleTime', event.target.checked)}
                disabled={loadingGettingRounding}
              />
            }
          />

          <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}>
            <RadioGroup
              value={formData.RadioUseScheduleTime}
              onChange={(event) => updateFormData('RadioUseScheduleTime', event.target.value)}
            >
              <FormControlLabel
                disabled={formData.CheckUseScheduleTime === false || loadingGettingRounding}
                label={t('settings.rounding_rule.table.modals.add.tabs.omitted_punch.projected_and_real_totals')}
                value={'totals_real_projected'}
                control={<Radio />}
              />

              <FormControlLabel
                disabled={formData.CheckUseScheduleTime === false || loadingGettingRounding}
                label={t('settings.rounding_rule.table.modals.add.tabs.omitted_punch.only_projected_totals')}
                value={'only_totals_projected'}
                control={<Radio />}
              />
            </RadioGroup>
          </Box>

          <FormControlLabel
            disabled={formData.CheckUseScheduleTime === false || loadingGettingRounding}
            label={t('settings.rounding_rule.table.modals.add.tabs.omitted_punch.treat_as_an_exception')}
            control={
              <Checkbox
                checked={formData.CheckTreatAsAnException}
                onChange={(event) => updateFormData('CheckTreatAsAnException', event.target.checked)}
              />
            }
          />
        </Grid>
      </Grid>
    </>
  )
}

export default Omitted
